<template>
    <div>
        <template v-if="type === 'didYouMeanQuery'">
            <i18n path="smartDidYouMeanInfo.didYouMean" tag="span" class="subtitle-1">
                <template #DID_YOU_MEAN_QUERY>
                    <a class="font-weight-bold font-italic clickable" @click="updateQuery(alternativeQuery)">{{ alternativeQuery }}</a>
                </template>
            </i18n>
        </template>
        <template v-else-if="type === 'improvedQuery'">
            <i18n path="smartDidYouMeanInfo.improvedQuery" tag="span" class="subtitle-1">
                <template #IMPROVED_QUERY>
                    <span class="font-weight-bold font-italic">"{{ alternativeQuery }}"</span>
                </template>
                <template #QUERY>
                    <a class="font-weight-bold font-italic clickable" @click="updateQuery(originalQuery)">{{ originalQuery }}</a>
                </template>
            </i18n>
        </template>
        <template v-else-if="type === 'correctedQuery'">
            <i18n path="smartDidYouMeanInfo.correctedQuery" tag="span" class="subtitle-1">
                <template #QUERY>
                    <span class="font-weight-bold font-italic">"{{ originalQuery }}"</span>
                </template>
                <template #CORRECTED_QUERY>
                    <span class="font-weight-bold font-italic">"{{ alternativeQuery }}"</span>
                </template>
            </i18n>
        </template>
    </div>
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator';

export default Vue.extend({
    name: 'SmartDidYouMeanInfo',
    props: {
        alternativeQuery: {
            type: String,
            default: '',
        },
        originalQuery: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            required: true,
        },
    },
    methods: {
        updateQuery(alternativeQuery: string): void {
            this.$emit('sdym-clicked', alternativeQuery);
        },
    },
});
</script>

<style scoped>
.clickable {
    cursor: pointer;
}
</style>
